export default "__VITE_ASSET__DiST2ecT__"